"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.abbreviatePlural = exports.NUMBER_FORMATS = exports.DATE_FORMATS = void 0;

var numbro_1 = __importDefault(require("numbro"));

var pluralize_1 = __importDefault(require("pluralize"));

exports.DATE_FORMATS = {
  FULL: 'MMMM D, YYYY [at] h:mm a',
  TEXT: 'MM/DD/YYYY h:mm A',
  TEXT_SHORT: 'MM/DD/YYYY',
  DATE: 'MMMM D, YYYY',
  MONTH_DAY: 'MMMM D',
  MONTH_DAY_SHORT: 'MMM D',
  TIME: 'h:mm a'
};
exports.NUMBER_FORMATS = {
  CURRENCY: {
    thousandSeparated: true,
    mantissa: 0
  },
  PERCENTAGE: {
    output: 'percent',
    mantissa: 2,
    optionalMantissa: true
  },
  PERCENTAGE_FULL: {
    output: 'percent',
    mantissa: 0
  },
  NUMBER: {
    thousandSeparated: true,
    mantissa: 0
  },
  ABBREVIATED: {
    average: true,
    mantissa: 1
  },
  DECIMAL: {
    thousandSeparated: true,
    mantissa: 2,
    optionalMantissa: true
  },
  FILESIZE: {
    output: 'byte',
    base: 'binary',
    mantissa: 1
  }
};
var ABBREVIATE_THRESHOLD = 1000;

var abbreviatePlural = function abbreviatePlural(word, number) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      showWord = _ref.showWord,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? ABBREVIATE_THRESHOLD : _ref$threshold;

  if (number >= threshold) {
    if (showWord) {
      return "".concat((0, numbro_1.default)(number).format(exports.NUMBER_FORMATS.ABBREVIATED), " ").concat(pluralize_1.default.plural(word));
    } else {
      return number.toString();
    }
  } else {
    if (showWord) {
      return (0, pluralize_1.default)(word, number, true);
    } else {
      return number.toString();
    }
  }
};

exports.abbreviatePlural = abbreviatePlural;